// src/main.jsx — Vite entry point for Lift Log v2.1.
// Phase 27 Stage C (VITE-03). Replaces the inline mount logic that lived at the
// bottom of `Lift Log App.html` (lines 223-263 in v2.0). The old polling-based
// mount waited for ~70 globals to be defined on `window`; with ES modules the
// dependency graph is satisfied at import time so no polling is needed.
//
// Phase 27 Stage D (VITE-09): StrictMode wrapped LAST, per PITFALLS P2 —
// enabling StrictMode mid-migration would mask double-render bugs that only
// surface on top of an otherwise clean tree. Double-invoke audit (Stage D
// notes in 027-SUMMARY.md): Dexie initPhotosDB idempotent; AudioContext uses
// `||` guard + Web Audio singleton survives via window.__llAudioContext;
// beforeinstallprompt listener has useEffect cleanup in PWAInit; A2HSPrompt
// timers cleaned up. `navigator.serviceWorker` message + controllerchange
// listeners added inside PWAInit useEffect without cleanup — NOT a real
// leak because controllerchange self-guards via `reloading` flag, and the
// message handler is idempotent (only reacts to RELOAD). Module-scoped
// keyframe injection in timers.jsx guards on document.getElementById.

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import { isNative } from './native.js';

const root = createRoot(document.getElementById('root'));
root.render(<StrictMode><App /></StrictMode>);

// Register the service worker (post-migration). The PWA update flow is
// handled by src/pwa.jsx which is imported from shell.jsx → App.jsx.
// The native (Capacitor) app serves its files from the APK: never a SW there.
const nativeShell = (() => { try { return isNative() || !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()); } catch (_) { return false; } })();
if ('serviceWorker' in navigator && !nativeShell) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch((err) => {
      console.warn('[main] SW registration failed:', err);
    });
  });
}
